module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-10.d56603ba.svg";